<p-button 
    icon="pi pi-trash"
    [rounded]="true"
    [text]="true"
    [pTooltip]="l('::Delete')"
    tooltipPosition="left"
    (onClick)="onClick()" />